<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['edit-website-title']"
    :description="propsdata[0]['translation']['edit-website-description']"
/>

<div v-if="loading" class="loader" style="margin: 100px auto;">
  <br><br>
  <div>
    <ul>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
    </ul>
  </div><span>{{propsdata[0]['translation']['edit-website-loading']}}</span>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
      <section class="section section-lg pt-0" style="padding-bottom: 8rem;">
         <div class="container" style="padding-top: 10rem;">
            <router-link to="/dashboard/websites" v-if="step === 2" class="text-primary" style="font-size: 25px;font-weight: 400;"><span class="icon icon-xs ml-2" style="margin-right: 10px; position: relative; bottom: 3px;"><i class="fas fa-arrow-left"></i></span>{{propsdata[0]['translation']['edit-website-back']}}</router-link>
            <hr v-if="step === 2">
            <div v-if="step === 2">
            <div>
            <h2>{{propsdata[0]['translation']['edit-website-privacy']}}</h2>
            <p v-if="enabled_pp" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-select']}} {{website}}</p>
            <p v-if="!enabled_pp" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-select-2']}}</p>
            <a v-if="enabled_pp" @click="Disable('Privacy Policy')" target="_blank" class="btn btn-secondary animate-up-2 cssbtnpolicies">{{propsdata[0]['translation']['edit-website-close']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-up"></i></span></a>
            <a v-if="!enabled_pp" @click="Enable('Privacy Policy')" target="_blank" class="btn animate-up-2 cssbtnpolicies" style="background:#0949b3;border-color:#0949b3;">{{propsdata[0]['translation']['edit-website-select']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-down"></i></span></a>
            <div v-if="enabled_pp" class="row mt-4">
              <div v-for="(privacy_policy, index) in policies[0].privacy_policies" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
                  <a @click="ChoosePPid(privacy_policy.unique_id); enabled_pp = false;" class="card hoverpolicies border-light shadow-soft p-4" :class='{"activepolicies": privacy_policy.unique_id == privacypolicyid}'>
                      <div class="card-body p-3">
                          <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                            <i v-if="privacy_policy.unique_id == privacypolicyid" class="fas fa-check" style="color:#90c42c;"></i>
                            <i v-else class="far fa-circle" style="color:#3f4654;"></i>
                          </div>
                          <h4 class="mb-4">{{privacy_policy.titulo}}</h4>
                          <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{privacy_policy.fecha}}</div>
                          <p v-if="privacy_policy.name" style="color: #3e4754;">{{privacy_policy.name}} {{propsdata[0]['translation']['edit-website-privacy']}}</p>
                      </div>
                  </a>
              </div>
              </div>
              <!-- chosen policy -->
              <div v-if="filteredPP.length > 0 && !enabled_pp" class="row mt-4">
                <div @click="Delete_policy('Privacy Policy')" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
                    <a class="card hoverpolicies border-light shadow-soft p-4 activepolicies_one">
                        <div class="card-body p-3">
                            <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                              <i class="fas fa-check icon_selected" style="color:#90c42c;"></i>
                              <i class="fas fa-times icon_unselect" style="display:none;color:#df182d;"></i>
                            </div>
                            <h4 class="mb-4">{{filteredPP[0].titulo}}</h4>
                            <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{filteredPP[0].fecha}}</div>
                            <p v-if="filteredPP[0].name" style="color: #3e4754;">{{filteredPP[0].name}} {{propsdata[0]['translation']['edit-website-privacy']}}</p>
                        </div>
                    </a>
                </div>
              </div>
              <div v-if="policies[0].privacy_policies === null && enabled_pp" class="sc-hcnlBt kVTXUr">
                <h4>{{propsdata[0]['translation']['edit-website-havent-generated-privacy']}}</h4><br>
                <a :href="propsdata[0]['translation']['link-edit-website-generate']" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
                  {{propsdata[0]['translation']['edit-website-generate-privacy']}}
                </a>
              </div>
          </div>
          <hr>
          <div>
          <h2>{{propsdata[0]['translation']['edit-website-terms']}}</h2>
          <p v-if="enabled_tc" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-select-terms']}} {{website}}</p>
          <p v-if="!enabled_tc" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-select-terms-2']}}</p>
          <a v-if="enabled_tc" @click="Disable('Terms & Conditions')" target="_blank" class="btn btn-secondary animate-up-2 cssbtnpolicies">{{propsdata[0]['translation']['edit-website-close']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-up"></i></span></a>
          <a v-if="!enabled_tc" @click="Enable('Terms & Conditions')" target="_blank" class="btn animate-up-2 cssbtnpolicies" style="background:#0949b3;border-color:#0949b3;">{{propsdata[0]['translation']['edit-website-select-terms-2']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-down"></i></span></a>
          <div v-if="enabled_tc" class="row mt-4">
            <div v-for="(term, index) in policies[0].terms" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
                <a @click="ChooseTCid(term.unique_id); enabled_tc = false;" class="card hoverpolicies border-light shadow-soft p-4" :class='{"activepolicies": term.unique_id == termsid}'>
                    <div class="card-body p-3">
                        <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                          <i v-if="term.unique_id == termsid" class="fas fa-check" style="color:#90c42c;"></i>
                          <i v-else class="far fa-circle" style="color:#3f4654;"></i>
                        </div>
                        <h4 class="mb-4">{{term.titulo}}</h4>
                        <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{term.fecha}}</div>
                        <p v-if="term.name" style="color: #3e4754;">{{term.name}} {{propsdata[0]['translation']['edit-website-terms']}}</p>
                    </div>
                </a>
            </div>
            </div>
            <!-- chosen policy -->
            <div v-if="filteredTC.length > 0 && !enabled_tc" class="row mt-4">
              <div @click="Delete_policy('Terms & Conditions')" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
                  <a class="card hoverpolicies border-light shadow-soft p-4 activepolicies_one">
                      <div class="card-body p-3">
                          <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                            <i class="fas fa-check icon_selected" style="color:#90c42c;"></i>
                            <i class="fas fa-times icon_unselect" style="display:none;color:#df182d;"></i>
                          </div>
                          <h4 class="mb-4">{{filteredTC[0].titulo}}</h4>
                          <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{filteredTC[0].fecha}}</div>
                          <p v-if="filteredTC[0].name" style="color: #3e4754;">{{filteredTC[0].name}} {{propsdata[0]['translation']['edit-website-terms']}}</p>
                      </div>
                  </a>
              </div>
            </div>
            <div v-if="policies[0].terms === null && enabled_tc" class="sc-hcnlBt kVTXUr">
              <h4>{{propsdata[0]['translation']['edit-website-loading']}}</h4><br>
              <a :href="propsdata[0]['translation']['link-edit-website-generate']" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
                {{propsdata[0]['translation']['edit-website-generate-terms']}}
              </a>
            </div>
        </div>
        <hr>
        <div>
        <h2>{{propsdata[0]['translation']['edit-website-disclaimer']}}</h2>
        <p v-if="enabled_d" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-disclaimer-select']}} {{website}}</p>
        <p v-if="!enabled_d" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-disclaimer-select']}}</p>
        <a v-if="enabled_d" @click="Disable('Disclaimer')" target="_blank" class="btn btn-secondary animate-up-2 cssbtnpolicies">{{propsdata[0]['translation']['edit-website-close']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-up"></i></span></a>
        <a v-if="!enabled_d" @click="Enable('Disclaimer')" target="_blank" class="btn animate-up-2 cssbtnpolicies" style="background:#0949b3;border-color:#0949b3;">{{propsdata[0]['translation']['edit-website-disclaimer-select3']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-down"></i></span></a>
        <div v-if="enabled_d" class="row mt-4">
          <div v-for="(disclaimer, index) in policies[0].disclaimers" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
              <a @click="ChooseDid(disclaimer.unique_id); enabled_d = false;" class="card hoverpolicies border-light shadow-soft p-4" :class='{"activepolicies": disclaimer.unique_id == disclaimerid}'>
                  <div class="card-body p-3">
                      <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                        <i v-if="disclaimer.unique_id == disclaimerid" class="fas fa-check" style="color:#90c42c;"></i>
                        <i v-else class="far fa-circle" style="color:#3f4654;"></i>
                      </div>
                      <h4 class="mb-4">{{disclaimer.titulo}}</h4>
                      <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{disclaimer.fecha}}</div>
                      <p v-if="disclaimer.name" style="color: #3e4754;">{{disclaimer.name}} {{propsdata[0]['translation']['edit-website-disclaimer']}}</p>
                  </div>
              </a>
          </div>
          </div>
          <!-- chosen policy -->
          <div v-if="filteredD.length > 0 && !enabled_d" class="row mt-4">
            <div @click="Delete_policy('Disclaimer')" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
                <a class="card hoverpolicies border-light shadow-soft p-4 activepolicies_one">
                    <div class="card-body p-3">
                        <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                          <i class="fas fa-check icon_selected" style="color:#90c42c;"></i>
                          <i class="fas fa-times icon_unselect" style="display:none;color:#df182d;"></i>
                        </div>
                        <h4 class="mb-4">{{filteredD[0].titulo}}</h4>
                        <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{filteredD[0].fecha}}</div>
                        <p v-if="filteredD[0].name" style="color: #3e4754;">{{filteredD[0].name}} {{propsdata[0]['translation']['edit-website-disclaimer']}}</p>
                    </div>
                </a>
            </div>
          </div>
          <div v-if="policies[0].disclaimers === null && enabled_d" class="sc-hcnlBt kVTXUr">
            <h4>{{propsdata[0]['translation']['edit-website-havent-generated-disclaimer']}}</h4><br>
            <a :href="propsdata[0]['translation']['link-edit-website-generate']" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
              {{propsdata[0]['translation']['edit-website-generate-disclaimer']}}
            </a>
          </div>
      </div>
      <hr>
      <div>
      <h2>{{propsdata[0]['translation']['edit-website-cookie-policy']}}</h2>
      <p v-if="enabled_cp" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-cookie-policy-select']}} {{website}}</p>
      <p v-if="!enabled_cp" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-cookie-policy-select2']}}</p>
      <a v-if="enabled_cp" @click="Disable('Cookie Policy')" target="_blank" class="btn btn-secondary animate-up-2 cssbtnpolicies">{{propsdata[0]['translation']['edit-website-close']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-up"></i></span></a>
      <a v-if="!enabled_cp" @click="Enable('Cookie Policy')" target="_blank" class="btn animate-up-2 cssbtnpolicies" style="background:#0949b3;border-color:#0949b3;">{{propsdata[0]['translation']['edit-website-cookie-policy-select3']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-down"></i></span></a>
      <div v-if="enabled_cp" class="row mt-4">
        <div v-for="(cookie_policy, index) in policies[0].cookie_policies" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
            <a @click="ChooseCPid(cookie_policy.unique_id); enabled_cp = false;" class="card hoverpolicies border-light shadow-soft p-4" :class='{"activepolicies": cookie_policy.unique_id == cookiepolicyid}'>
                <div class="card-body p-3">
                    <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                      <i v-if="cookie_policy.unique_id == cookiepolicyid" class="fas fa-check" style="color:#90c42c;"></i>
                      <i v-else class="far fa-circle" style="color:#3f4654;"></i>
                    </div>
                    <h4 class="mb-4">{{cookie_policy.titulo}}</h4>
                    <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{cookie_policy.fecha}}</div>
                    <p v-if="cookie_policy.name" style="color: #3e4754;">{{cookie_policy.name}} {{propsdata[0]['translation']['edit-website-cookie-policy']}}</p>
                </div>
            </a>
        </div>
        </div>
        <!-- chosen policy -->
        <div v-if="filteredCP.length > 0 && !enabled_cp" class="row mt-4">
          <div @click="Delete_policy('Cookie Policy')" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
              <a class="card hoverpolicies border-light shadow-soft p-4 activepolicies_one">
                  <div class="card-body p-3">
                      <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                        <i class="fas fa-check icon_selected" style="color:#90c42c;"></i>
                        <i class="fas fa-times icon_unselect" style="display:none;color:#df182d;"></i>
                      </div>
                      <h4 class="mb-4">{{filteredCP[0].titulo}}</h4>
                      <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{filteredCP[0].fecha}}</div>
                      <p v-if="filteredCP[0].name" style="color: #3e4754;">{{filteredCP[0].name}} {{propsdata[0]['translation']['edit-website-cookie-policy']}}</p>
                  </div>
              </a>
          </div>
        </div>
        <div v-if="policies[0].cookie_policies === null && enabled_cp" class="sc-hcnlBt kVTXUr">
          <h4>{{propsdata[0]['translation']['edit-website-havent-generated-cookie-policy']}}</h4><br>
          <a :href="propsdata[0]['translation']['link-edit-website-generate']" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
            {{propsdata[0]['translation']['edit-website-generate-cookie-policy']}}
          </a>
        </div>
    </div>
    <hr>
    <div>
    <h2>EULA</h2>
    <p v-if="enabled_eula" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-eula-select']}} {{website}}</p>
    <p v-if="!enabled_eula" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-eula-select2']}}</p>
    <a v-if="enabled_eula" @click="Disable('EULA')" target="_blank" class="btn btn-secondary animate-up-2 cssbtnpolicies">{{propsdata[0]['translation']['edit-website-close']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-up"></i></span></a>
    <a v-if="!enabled_eula" @click="Enable('EULA')" target="_blank" class="btn animate-up-2 cssbtnpolicies" style="background:#0949b3;border-color:#0949b3;">{{propsdata[0]['translation']['edit-website-eula-select3']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-down"></i></span></a>
    <div v-if="enabled_eula" class="row mt-4">
      <div v-for="(eula, index) in policies[0].eulas" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
          <a @click="ChooseEULAid(eula.unique_id); enabled_eula = false;" class="card hoverpolicies border-light shadow-soft p-4" :class='{"activepolicies": eula.unique_id == eulaid}'>
              <div class="card-body p-3">
                  <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                    <i v-if="eula.unique_id == eulaid" class="fas fa-check" style="color:#90c42c;"></i>
                    <i v-else class="far fa-circle" style="color:#3f4654;"></i>
                  </div>
                  <h4 class="mb-4">{{eula.titulo}}</h4>
                  <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{eula.fecha}}</div>
                  <p v-if="eula.name" style="color: #3e4754;">{{eula.name}} EULA</p>
              </div>
          </a>
      </div>
      </div>
      <!-- chosen policy -->
      <div v-if="filteredEULA.length > 0 && !enabled_eula" class="row mt-4">
        <div @click="Delete_policy('EULA')" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
            <a class="card hoverpolicies border-light shadow-soft p-4 activepolicies_one">
                <div class="card-body p-3">
                    <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                      <i class="fas fa-check icon_selected" style="color:#90c42c;"></i>
                      <i class="fas fa-times icon_unselect" style="display:none;color:#df182d;"></i>
                    </div>
                    <h4 class="mb-4">{{filteredEULA[0].titulo}}</h4>
                    <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{filteredEULA[0].fecha}}</div>
                    <p v-if="filteredEULA[0].name" style="color: #3e4754;">{{filteredEULA[0].name}} EULA</p>
                </div>
            </a>
        </div>
      </div>
      <div v-if="policies[0].eulas === null && enabled_eula" class="sc-hcnlBt kVTXUr">
        <h4>{{propsdata[0]['translation']['edit-website-havent-generated-eula']}}</h4><br>
        <a :href="propsdata[0]['translation']['link-edit-website-generate']" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
          {{propsdata[0]['translation']['edit-website-generate-eula']}}
        </a>
      </div>
  </div>
  <hr>
  <div>
  <h2>{{propsdata[0]['translation']['edit-website-refund']}}</h2>
  <p v-if="enabled_rr" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-refund-select']}} {{website}}</p>
  <p v-if="!enabled_rr" style="display: inline-block;">{{propsdata[0]['translation']['edit-website-refund-select2']}}</p>
  <a v-if="enabled_rr" @click="Disable('Return & Refund')" target="_blank" class="btn btn-secondary animate-up-2 cssbtnpolicies">{{propsdata[0]['translation']['edit-website-close']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-up"></i></span></a>
  <a v-if="!enabled_rr" @click="Enable('Return & Refund')" target="_blank" class="btn animate-up-2 cssbtnpolicies" style="background:#0949b3;border-color:#0949b3;">{{propsdata[0]['translation']['edit-website-refund-select3']}}<span class="icon icon-xs ml-3"><i class="fas fa-chevron-down"></i></span></a>
  <div v-if="enabled_rr" class="row mt-4">
    <div v-for="(return_and_refund, index) in policies[0].return_and_refunds" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
        <a @click="ChooseRRid(return_and_refund.unique_id); enabled_rr = false;" class="card hoverpolicies border-light shadow-soft p-4" :class='{"activepolicies": return_and_refund.unique_id == returnandrefundid}'>
            <div class="card-body p-3">
                <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                  <i v-if="return_and_refund.unique_id == returnandrefundid" class="fas fa-check" style="color:#90c42c;"></i>
                  <i v-else class="far fa-circle" style="color:#3f4654;"></i>
                </div>
                <h4 class="mb-4">{{return_and_refund.titulo}}</h4>
                <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{return_and_refund.fecha}}</div>
                <p v-if="return_and_refund.name" style="color: #3e4754;">{{return_and_refund.name}} {{propsdata[0]['translation']['edit-website-refund']}}</p>
            </div>
        </a>
    </div>
    </div>
    <!-- chosen policy -->
    <div v-if="filteredRR.length > 0 && !enabled_rr" class="row mt-4">
      <div @click="Delete_policy('Return & Refund')" class="col-12 col-lg-6 mb-lg-0" style="padding: 15px;">
          <a class="card hoverpolicies border-light shadow-soft p-4 activepolicies_one">
              <div class="card-body p-3">
                  <div class="icon icon-lg justify-content-start mb-3" style="float:right;">
                    <i class="fas fa-check icon_selected" style="color:#90c42c;"></i>
                    <i class="fas fa-times icon_unselect" style="display:none;color:#df182d;"></i>
                  </div>
                  <h4 class="mb-4">{{filteredRR[0].titulo}}</h4>
                  <div class="sc-hizQCF dXstwa">{{propsdata[0]['translation']['edit-website-created']}} {{filteredRR[0].fecha}}</div>
                  <p v-if="filteredRR[0].name" style="color: #3e4754;">{{filteredRR[0].name}} {{propsdata[0]['translation']['edit-website-refund']}}</p>
              </div>
          </a>
      </div>
    </div>
    <div v-if="policies[0].return_and_refunds === null && enabled_rr" class="sc-hcnlBt kVTXUr">
      <h4>{{propsdata[0]['translation']['edit-website-havent-refund']}}</h4><br>
      <a :href="propsdata[0]['translation']['link-edit-website-generate']" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
        {{propsdata[0]['translation']['edit-website-generate-refund']}}
      </a>
    </div>
</div>
</div>
</div>
</section>
      <div v-if="step === 2" style="text-align: center;position: relative;top: -70px;">
      <a v-if="!saving" @click="Save" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;"><i class="fas fa-save" style="margin-right: 8px;margin-left: 6px;"></i>
        {{propsdata[0]['translation']['edit-website-save']}}
      </a>
      <a v-if="saving" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;"><i class="fas fa-spinner" style="margin-right: 8px;margin-left: 6px;"></i>
        {{propsdata[0]['translation']['edit-website-saving']}}...
      </a>
    </div>

  </div>
</div>

</template>

<style>
.activepolicies{
  border: 2px solid #90c42c!important;
}
.activepolicies_one{
  border: 2px solid #90c42c!important;
}
.activepolicies_one:hover{
  border: 2px solid #df182d!important;
}
.activepolicies_one:hover .icon_selected{
  display: none!important;
}
.activepolicies_one:hover .icon_unselect{
  display: inherit!important;
}
.hoverpolicies:hover{
  background-color: #f7f7f7 !important;
}
@media (min-width:992px) {
  .cssbtnpolicies{
    float: right;
    display: inline-block;
    position: relative;
    bottom: 25px;
  }
}
.cssbtnpolicies{
  color:#ffffff!important;
  display: block;
}
</style>

  <script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        scriptid: '',
        step: 2,
        website: '',
        error: false,
        policies: [],
        privacypolicyid: '',
        termsid: '',
        disclaimerid: '',
        cookiepolicyid: '',
        eulaid: '',
        returnandrefundid: '',
        enabled_pp: false,
        enabled_tc: false,
        enabled_d: false,
        enabled_cp: false,
        enabled_eula: false,
        enabled_rr: false,
        saving: false
      };
    },
    computed: {
      filteredPP() {
        if (this.policies[0] && this.policies[0].privacy_policies) {
          return this.policies[0].privacy_policies.filter(
            (policy) => policy.unique_id === this.privacypolicyid
          );
        }
        return [];
      },
      filteredTC() {
        if (this.policies[0] && this.policies[0].terms) {
          return this.policies[0].terms.filter(
            (policy) => policy.unique_id === this.termsid
          );
        }
        return [];
      },
      filteredD() {
        if (this.policies[0] && this.policies[0].disclaimers) {
          return this.policies[0].disclaimers.filter(
            (policy) => policy.unique_id === this.disclaimerid
          );
        }
        return [];
      },
      filteredCP() {
        if (this.policies[0] && this.policies[0].cookie_policies) {
          return this.policies[0].cookie_policies.filter(
            (policy) => policy.unique_id === this.cookiepolicyid
          );
        }
        return [];
      },
      filteredEULA() {
        if (this.policies[0] && this.policies[0].eulas) {
          return this.policies[0].eulas.filter(
            (policy) => policy.unique_id === this.eulaid
          );
        }
        return [];
      },
      filteredRR() {
        if (this.policies[0] && this.policies[0].return_and_refunds) {
          return this.policies[0].return_and_refunds.filter(
            (policy) => policy.unique_id === this.returnandrefundid
          );
        }
        return [];
      }
    },
    methods: {
      policieselegidas(){
        axios.post('/dashboard/chosen-policies.php', {
          scriptid: this.scriptid
          })
          .then(response => {
            if(response.data == 'no es su website'){
              window.location.replace("https://termify.io/dashboard/websites");
            }
            else{
            this.website = response.data[0].website;
            if(response.data[0].privacypolicyid){
              this.privacypolicyid = response.data[0].privacypolicyid;
            }
            if(response.data[0].termsid){
              this.termsid = response.data[0].termsid;
            }
            if(response.data[0].disclaimerid){
              this.disclaimerid = response.data[0].disclaimerid;
            }
            if(response.data[0].cookiepolicyid){
              this.cookiepolicyid = response.data[0].cookiepolicyid;
            }
            if(response.data[0].eulaid){
              this.eulaid = response.data[0].eulaid;
            }
            if(response.data[0].returnandrefundid){
              this.returnandrefundid = response.data[0].returnandrefundid;
            }
            this.loading = false;
          }
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      ChoosePPid(text){
        this.privacypolicyid = text;
      },
      ChooseTCid(text){
        this.termsid = text;
      },
      ChooseDid(text){
        this.disclaimerid = text;
      },
      ChooseCPid(text){
        this.cookiepolicyid = text;
      },
      ChooseEULAid(text){
        this.eulaid = text;
      },
      ChooseRRid(text){
        this.returnandrefundid = text;
      },
      Delete_policy(text){
        if(text == 'Privacy Policy'){
          this.privacypolicyid = '';
        }
        else if(text == 'Terms & Conditions'){
          this.termsid = '';
        }
        else if(text == 'Disclaimer'){
          this.disclaimerid = '';
        }
        else if(text == 'Cookie Policy'){
          this.cookiepolicyid = '';
        }
        else if(text == 'EULA'){
          this.eulaid = '';
        }
        else if(text == 'Return & Refund'){
          this.returnandrefundid = '';
        }
      },
      Disable(text){
        if(text == 'Privacy Policy'){
          this.enabled_pp = false;
        }
        else if(text == 'Terms & Conditions'){
          this.enabled_tc = false;
        }
        else if(text == 'Disclaimer'){
          this.enabled_d = false;
        }
        else if(text == 'Cookie Policy'){
          this.enabled_cp = false;
        }
        else if(text == 'EULA'){
          this.enabled_eula = false;
        }
        else if(text == 'Return & Refund'){
          this.enabled_rr = false;
        }
      },
      Enable(text){
        if(text == 'Privacy Policy'){
          this.enabled_pp = true;
        }
        else if(text == 'Terms & Conditions'){
          this.enabled_tc = true;
        }
        else if(text == 'Disclaimer'){
          this.enabled_d = true;
        }
        else if(text == 'Cookie Policy'){
          this.enabled_cp = true;
        }
        else if(text == 'EULA'){
          this.enabled_eula = true;
        }
        else if(text == 'Return & Refund'){
          this.enabled_rr = true;
        }
      },
      Save(){
        if(this.enabled_pp && this.privacypolicyid == ''){
          this.error = true;
          var element = document.querySelector("#pp");
          // smooth scroll to element and align it at the bottom
          element.scrollIntoView({ behavior: 'smooth', block: 'center'});
        }
        else if(this.enabled_tc && this.termsid == ''){
          this.error = true;
          var element = document.querySelector("#tc");
          // smooth scroll to element and align it at the bottom
          element.scrollIntoView({ behavior: 'smooth', block: 'center'});
        }
        else if(this.enabled_d && this.disclaimerid == ''){
          this.error = true;
          var element = document.querySelector("#d");
          // smooth scroll to element and align it at the bottom
          element.scrollIntoView({ behavior: 'smooth', block: 'center'});
        }
        else if(this.enabled_cp && this.cookiepolicyid == ''){
          this.error = true;
          var element = document.querySelector("#cp");
          // smooth scroll to element and align it at the bottom
          element.scrollIntoView({ behavior: 'smooth', block: 'center'});
        }
        else if(this.enabled_eula && this.eulaid == ''){
          this.error = true;
          var element = document.querySelector("#eula");
          // smooth scroll to element and align it at the bottom
          element.scrollIntoView({ behavior: 'smooth', block: 'center'});
        }
        else if(this.enabled_rr && this.returnandrefundid == ''){
          this.error = true;
          var element = document.querySelector("#rr");
          // smooth scroll to element and align it at the bottom
          element.scrollIntoView({ behavior: 'smooth', block: 'center'});
        }
        else{
          this.saving = true;
          this.error = false;
          axios.post('/dashboard/edit-website.php', {
            scriptid: this.scriptid,
            website: this.website,
            privacypolicyid: this.privacypolicyid,
            termsid: this.termsid,
            disclaimerid: this.disclaimerid,
            cookiepolicyid: this.cookiepolicyid,
            eulaid: this.eulaid,
            returnandrefundid: this.returnandrefundid
            })
            .then(response => {
              this.saving = false;
              window.location.replace("https://termify.io/dashboard/websites");
          })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    mounted() {
      this.scriptid = this.$route.params.scriptid;
      //todas las policies
      axios.post('/dashboard/cargar-policies-websites.php', {
        scriptid: this.scriptid
        })
        .then(response => {
          if(response.data == 'no pago'){
            window.location.replace("https://termify.io/choose-plan/"+this.propsdata[0].unique_id);
          }
          else{
          this.policies = response.data;
          this.policieselegidas();
          }
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  </script>



// WEBPACK FOOTER //
// src/edit-website.vue